/**
 * 사업계획 양식관리 — 공통 FormRegistryPanel (BIZ_PLAN) 위임
 * 환경설정 › 양식 레지스트리와 동일 스토어 (CM-DESIGN-005)
 */
import React from 'react';
import styled from 'styled-components';
import { PageContainer } from 'styles/common.styles';
import FormRegistryPanel from 'pages/system/FormRegistryPanel';
import { DOC_TYPE } from 'system/formDocTypes';

const Hint = styled.p`
  margin: 0 0 6px;
  font-size: 11px;
  color: var(--erp-text-secondary);
`;

const BizFormTemplateManage = () => (
  <PageContainer>
    <Hint>
      사업계획 양식은 환경설정 › 양식 레지스트리에도 있습니다. 동일 카탈로그·기관 연결을 사용합니다.
    </Hint>
    <FormRegistryPanel fixedDocType={DOC_TYPE.BIZ_PLAN} hideDocTypeFilter embedded />
  </PageContainer>
);

export default BizFormTemplateManage;
